const patInfoStore = {
    state: {
        patName: '',
        patRrn: '',
        patHpNo: '',
        patBirth: '',
        ptNo: '',
        rplFlag: ''
    },
    mutations: {
        setPatName(state, patName) {
            state.patName = patName;
        },
        setPatRrn(state, patRrn) {
            state.patRrn = patRrn;
        },
        setPatBirth(state, patBirth) {
            state.patBirth = patBirth
        },
        setPatHpNo(state, patHpNo) {
            state.patHpNo = patHpNo
        },
        setPtNo(state, ptNo) {
            state.ptNo = ptNo
        },
        setRplFlag(state, rplFlag) {
            state.rplFlag = rplFlag
        },

        // 초기화
        patInfoInit: function(state){
            for(let i in state) {
                state[i] = ''
            }
        }
    }
}

export default patInfoStore